import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import Email from './icons/email.svg';
import Sms from './icons/sms.svg';
import Push from './icons/push.svg';
import { DeliveryChannel } from '../../components/delivery-channel-switch/types';
import { useEditableField } from '../use-editable-field';
import { useSession } from '../../../../../infra/session';
import { canUseSmsChannel } from '../../utils/delivery-channels';
export var useDeliveryChannel = function () {
    var sendSmsField = useEditableField('sendSms').field;
    var sendEmailField = useEditableField('sendEmail').field;
    var sendPushField = useEditableField('sendPush').field;
    var customDeliveryChannelsField = useEditableField('usesCustomDeliveryChannels').field;
    var session = useSession().data;
    var smsChannelEnabled = canUseSmsChannel({ session: session });
    var availableDeliveryChannelsOptions = [
        {
            id: DeliveryChannel.EMAIL,
            name: 'Email',
            Icon: _jsx(Email, {}),
            isAvailable: sendEmailField.value || !customDeliveryChannelsField.value,
        },
        {
            id: DeliveryChannel.SMS,
            name: 'SMS',
            Icon: _jsx(Sms, {}),
            isAvailable: sendSmsField.value || (smsChannelEnabled && !customDeliveryChannelsField.value),
        },
        {
            id: DeliveryChannel.PUSH,
            name: 'Push',
            Icon: _jsx(Push, {}),
            isAvailable: sendPushField.value || !customDeliveryChannelsField.value,
        },
    ].filter(function (option) { return option.isAvailable; });
    var _a = useState(availableDeliveryChannelsOptions[0].id), selectedDeliveryChannel = _a[0], setSelectedDeliveryChannel = _a[1];
    return {
        availableDeliveryChannelsOptions: availableDeliveryChannelsOptions,
        selectedDeliveryChannel: selectedDeliveryChannel,
        setSelectedDeliveryChannel: setSelectedDeliveryChannel,
    };
};
